import { Phone01 } from '@untitledui/icons';
import type { FC } from 'react';

export const QuoIcon: FC<{ className?: string }> = ({ className }) => (
  <Phone01 className={className} aria-hidden='true' />
);
